import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=09a7dbdb&"
import script from "./UploadFile.vue?vue&type=script&lang=js&"
export * from "./UploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.vlaams-brabant/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton, BFormFile, BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BButton, BFormFile, BCol, BRow})
    

export default component.exports